<template>
	<div class="row" style="width: 100%;">
		<button @click="showModal" data-toggle="modal" data-target="#modalDetailDevice" class="col col-lg-8 mr-1 btn btn-secondary">Detail</button>
        <div class="dropdown">
            <button class="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <router-link tag="a" class="dropdown-item" :to="target">Edit</router-link>
                <div class="dropdown-divider"></div>
                <a v-if="this.$route.name == 'DriverIndex' && data.status == 3" @click="$emit('deletedId', selectedId)" class="dropdown-item" :href="`#${targetModal}`" data-toggle="modal">
					{{ this.$route.name == 'DriverIndex' ? 'Aktifkan' : 'Hapus'}}
				</a>
				<a v-else @click="$emit('deletedId', selectedId)" class="dropdown-item" :href="`#${targetModal}`" data-toggle="modal">
					{{ this.$route.name == 'DriverIndex' ? 'Nonaktifkan' : 'Hapus'}}
				</a>
				<div v-if="this.$route.name == 'DriverIndex' && data.id_device != null" >
					<div class="dropdown-divider"></div>
					<a @click="removeDevice(selectedId)" class="dropdown-item" href="#">
						Hapus Device
					</a>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/plugins/bus.js'

export default {
	name: 'ActionEditDeleteDetail',
	props: ['target', 'selectedId', 'data', 'targetModal'],
	methods: {
		showModal() {
			let _ = this			
			EventBus.$emit('modalDetail'+ this.$route.name, _.data)			
		},
		removeDevice(x){
			let _ = this
			_.axios.patch('/driver/remove_device', { id: x })
				.then(res => {
					if ( res.data.status ) {
						EventBus.$emit('deleteEvent'+ this.$route.name, true);
						$('#' + _.targetModal).click()
					}
				})
				.catch(err => {
					$('#' + _.targetModal).click()
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		}
	}
}
</script>